// Cart
import '//misssixty.com/cdn/shop/t/89/assets/m-cart.js?v=85987852826810250131745899070'; 

// (Cart) Open the cart dialog + update header cart counter
document.addEventListener('liquid-ajax-cart:request-end', event => {
    const {requestState} = event.detail;

    // If the "add to cart" request is successful
    if (requestState.requestType === 'add' && requestState.responseData?.ok) {
        // Open the cart dialog
        const cartBox = document.getElementById('cartBox');
        if (cartBox) cartBox.open();
    }
});

// (Cart) Update header cart counter 
document.addEventListener("liquid-ajax-cart:queue-end", function() {
    let itemCount = window.liquidAjaxCart.cart.item_count; // Get the item count
    document.querySelectorAll('[data-count]').forEach(function(el) {
        el.setAttribute('data-count', itemCount); // Update the data-count attribute
    });
});

// (Cart) Add attribute while product being added to cart
document.addEventListener('liquid-ajax-cart:request-start', event => {
    const {requestState} = event.detail;
    if (requestState.requestType === 'add') document.body.setAttribute('cart-state', 'processing')
});

// (Cart) Add attribute when product is added to cart
document.addEventListener('liquid-ajax-cart:request-end', event => {
    const {requestState} = event.detail;
    if (requestState.requestType === 'add') {
        document.body.removeAttribute('cart-state', 'processing');
        document.body.setAttribute('cart-state', 'done');
        setTimeout(function() { document.body.removeAttribute('cart-state', 'done') }, 4000);
    }
});

document.addEventListener('liquid-ajax-cart:request-end', event => {
  document.querySelectorAll('[data-ajax-cart-section] [data-ajax-cart-details]').forEach($details => {
    const key = $details.getAttribute('data-ajax-cart-details');
    if (!key) return;
    $details.open = cartDetailsOpen[key];
  });
  cartDetailsInit();
});

// (Cart) Fix for details stays open
const cartDetailsOpen = {};
function cartDetailsInit() {
  document.querySelectorAll('[data-ajax-cart-section] [data-ajax-cart-details]').forEach($details => {
    const key = $details.getAttribute('data-ajax-cart-details');
    if (!key) return;
    cartDetailsOpen[key] = $details.hasAttribute('open');
    $details.addEventListener('toggle', event => {
      cartDetailsOpen[key] = event.target.open;
    });
  });
  
  initCurrencyShippingTips();
}
cartDetailsInit();

// custom-method
function initCurrencyShippingTips(){
  let currentCurrencyRate = Shopify && Shopify.currency && Shopify.currency.rate ? Shopify.currency.rate : 0;
  const cartShippingElement = document.querySelector('cart-shipping');
  let threshold = cartShippingElement ? cartShippingElement.getAttribute('data-threshold') : 0;
  let calculatedTotalPrice = cartShippingElement ? cartShippingElement.getAttribute('data-calculatedTotalPrice') : 0;
  let freeShippingAwayToMoney = cartShippingElement ? cartShippingElement.getAttribute('data-freeShippingAway') : 0;
  let symbolIsComma = freeShippingAwayToMoney && String(freeShippingAwayToMoney).indexOf(',') > -1;
  // 创建一个数字格式化对象，指定语言环境（locale）为国家代码（country code）为德国，这样可以得到"169,9"这样的格式
  const commaFormatter = new Intl.NumberFormat('de-DE');
  
  const isFreeShipping = calculatedTotalPrice >= (threshold * currentCurrencyRate) ? true : false;
  const isFreeShippingElement = document.querySelector('.is-free-shipping');
  const notFreeShippingElement = document.querySelector('.not-free-shipping');
  isFreeShippingElement.style.display = isFreeShipping ? 'block' : 'none';
  notFreeShippingElement.style.display = !isFreeShipping ? 'block' : 'none';
  
  function updateAmount(selector) {
    const element = document.querySelector(selector);
    if (element && currentCurrencyRate) {
      let text = element.textContent.trim();
      // 默认：取现有值，修改汇率 （注：只有selector为'.freeShippingAmount'，固定）
      let value = parseFloat(text.match(/[\d\.\,\-]+/)[0]);
      let newValue = Number((value * currentCurrencyRate).toFixed(2));

      if(selector === '.not-free-shipping .awayAmount'){
        newValue = Number(((threshold * currentCurrencyRate) - calculatedTotalPrice).toFixed(2));
        let progressElement = document.getElementById('frees-shipping-progress');
        if(progressElement){
          progressElement.max = threshold * currentCurrencyRate;
          progressElement.value = calculatedTotalPrice;
        }

        if(newValue && symbolIsComma){
          newValue = commaFormatter.format(newValue);
        }
      }
      element.textContent = text.replace(/[\d\.\,\-]+/, newValue);
    }
  }

  if(isFreeShipping){
    updateAmount('.is-free-shipping .freeShippingAmount');
  }else{
    updateAmount('.not-free-shipping .freeShippingAmount');
    updateAmount('.not-free-shipping .awayAmount');
  }
}

// Remove in production
//window.liquidAjaxCart.conf('updateOnWindowFocus', false);